import { render, staticRenderFns } from "./Protocolo.vue?vue&type=template&id=4df165d0&scoped=true"
import script from "./Protocolo.vue?vue&type=script&lang=ts"
export * from "./Protocolo.vue?vue&type=script&lang=ts"
import style0 from "./Protocolo.vue?vue&type=style&index=0&id=4df165d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df165d0",
  null
  
)

export default component.exports